import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DbcListComponent } from './dbc-list/dbc-list.component';

const routes: Routes = [
    {
        path: '',
        data: {
            title: 'My Cards',
        },
        component: DbcListComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DigitalBusinessCardRoutingModule {}
